import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { User } from '@/models/user/user';
import { usersService } from '@/services/users';

@Component
export default class UserEdit extends Vue {
    user: User = null;
    loading = false;
    roleOptions = [
        { value: 'ADMIN', text: 'Administrator' },
        { value: 'SIMPLE', text: 'Customer' }
    ];

    async mounted() {
        const userId = parseInt(this.$route.params.id);
        if (isNaN(userId)) {
            this.$router.push('/users');
            return;
        }

        this.loading = true;
        try {
            this.user = await usersService.getById(userId);
            if (!this.user) {
                this.$router.push('/users');
            }
        } catch (error) {
            this.$bvToast.toast('Failed to load user', {
                title: 'Error',
                variant: 'danger'
            });
            this.$router.push('/users');
        } finally {
            this.loading = false;
        }
    }

    async save() {
        this.loading = true;
        try {
            await usersService.updateUser(this.user);
            this.$router.push('/users');
        } catch (error) {
            this.$bvToast.toast('Failed to update user', {
                title: 'Error',
                variant: 'danger'
            });
        } finally {
            this.loading = false;
        }
    }

    cancel() {
        this.$router.push('/users');
    }

    async deleteUser() {
        if (await this.$confirmWarning(`Are you sure you want to delete User '${this.user.username}'?`)) {
            this.loading = true;
            try {
                await usersService.deleteUser({ resourceId: this.user.id });
                this.$router.push('/users');
            } catch (error) {
                this.$bvToast.toast('Failed to delete user', {
                    title: 'Error',
                    variant: 'danger'
                });
            } finally {
                this.loading = false;
            }
        }
    }
}
